var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-window mt-3 mr-3 border bd-e4 p-3"},[_c('HeaderWindow',{attrs:{"title":_vm.title,"show_calll":true},on:{"onClose":_vm.onClose}}),_c('CallLogsTable',{attrs:{"current_page":_vm.current_page,"logs":_vm.call_logs},on:{"getCallLogs":_vm.getCallLogs}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }